import { Injectable, inject } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../../../environments/environment'
import { RestClientPaged } from '@elderbyte/ngx-starter'
import { Observable } from 'rxjs'
import { Operation } from '../operations/operation'

@Injectable({
  providedIn: 'root',
})
export class WorkInstructionService extends RestClientPaged<Operation, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/work-instructions', http)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public getOperations(workItemId: string, workCenterId: string): Observable<Operation[]> {
    return this.http.get<Operation[]>(this.restEndpoint, {
      params: {
        workItemId: workItemId,
        workCenterId: workCenterId,
      },
    })
  }
}
